import { userInteractionAction, ViewType } from 'owa-calendar-actions';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

const TEAMS_HOST_NAME = 'teams.microsoft.com';
const SKYPE_HOST_NAME = 'join.microsoft.com';

/**
 * Function that logs telemetry if the link clicked launches an Online Meeting
 * @param viewType Calendar View that is displaying the link
 * @param event onClick event generated by the user
 * @param The Calendar Event that has the join online meeting invite
 * @param isCTRLKeyAndClickEnforced Edit mode requires CTRL+click for the link to operate correctly and launch Teams or Skype
 */
export function logTelemetryForJoinMeetingLink(
    viewType: ViewType,
    event: any,
    item: CalendarEvent,
    isCTRLKeyAndClickEnforced: boolean = false
) {
    if (!event || !item) {
        return;
    }

    const target = event.target as HTMLAnchorElement;

    if (
        target &&
        ((target.host === TEAMS_HOST_NAME && target.hostname === TEAMS_HOST_NAME) ||
            (target.host === SKYPE_HOST_NAME && target.hostname === SKYPE_HOST_NAME)) &&
        (!isCTRLKeyAndClickEnforced || event.ctrlKey)
    ) {
        userInteractionAction(
            'JoinOnlineMeetingThruLink',
            viewType,
            item.IsOrganizer,
            item.IsMeeting,
            [item.OnlineMeetingProvider]
        );
    }
}
